const REGEX_ENDSWITH_PERCENT_PX = /%|px$/;
const REGEX_ENDSWITH_PERCENT_PX_MAX = /%|px|max$/;
function nomalizeHeightValue(height) {
  var _a;
  const unit = (_a = height.match(REGEX_ENDSWITH_PERCENT_PX)) == null ? void 0 : _a[0];
  if (unit) {
    const nomalizedHeight = Math.ceil(parseFloat(height));
    return nomalizedHeight + unit;
  }
  return height;
}
function validateHeightParameter(height) {
  if (height) {
    return REGEX_ENDSWITH_PERCENT_PX_MAX.test(height);
  } else {
    return true;
  }
}
export {
  nomalizeHeightValue,
  validateHeightParameter
};
